import React from 'react';
import { UsersIcon, HeartHandshakeIcon, LandmarkIcon } from 'lucide-react';
export const Audience = () => {
  return <section className="py-12 sm:py-16 bg-gray-50" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="text-center" data-id="element-15">
          <h2 className="text-base text-[#990000] font-semibold tracking-wide uppercase" data-id="element-16">
            Who It's For
          </h2>
          <p className="mt-2 text-2xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-3xl md:text-4xl" data-id="element-17">
            Created for families who cherish their heritage
          </p>
        </div>
        <div className="mt-8 sm:mt-10" data-id="element-18">
          <div className="space-y-8 md:space-y-0 md:grid md:grid-cols-3 md:gap-x-8 md:gap-y-10" data-id="element-19">
            <div className="text-center" data-id="element-20">
              <div className="flex items-center justify-center h-16 w-16 rounded-full bg-[#0A2463] text-white mx-auto" data-id="element-21">
                <UsersIcon className="h-8 w-8" data-id="element-22" />
              </div>
              <h3 className="mt-4 text-lg leading-6 font-medium text-gray-900" data-id="element-23">
                Parents
              </h3>
              <p className="mt-2 text-sm sm:text-base text-gray-500" data-id="element-24">
                Who want to instill lasting principles in their children.
              </p>
            </div>
            <div className="text-center" data-id="element-25">
              <div className="flex items-center justify-center h-16 w-16 rounded-full bg-[#0A2463] text-white mx-auto" data-id="element-26">
                <HeartHandshakeIcon className="h-8 w-8" data-id="element-27" />
              </div>
              <h3 className="mt-4 text-lg leading-6 font-medium text-gray-900" data-id="element-28">
                Grandparents
              </h3>
              <p className="mt-2 text-sm sm:text-base text-gray-500" data-id="element-29">
                Who want to leave behind a gift of wisdom.
              </p>
            </div>
            <div className="text-center" data-id="element-30">
              <div className="flex items-center justify-center h-16 w-16 rounded-full bg-[#0A2463] text-white mx-auto" data-id="element-31">
                <LandmarkIcon className="h-8 w-8" data-id="element-32" />
              </div>
              <h3 className="mt-4 text-lg leading-6 font-medium text-gray-900" data-id="element-33">
                Families
              </h3>
              <p className="mt-2 text-sm sm:text-base text-gray-500" data-id="element-34">
                Who believe in preserving faith, freedom, and the American
                dream.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};